export enum LangWord {
    Ok = 'word.ok',
    Cancel = 'word.cancel',
}
